import React from "react";
import CommonLogin from '../../../common/CommonLogin';

function SubAdminLogin() {
  return (
    <CommonLogin
      header={"Sub-Admin Login"}
      afterLogin={"/subadmin/dashboard"}
      loginFailed={"/subadmin/login"}
      prem_name={"subadmin"} // This matches the 'subadmin' permission name we set in backend checkAuthenticity
    />
  );
}

export default SubAdminLogin;
